import React from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CountUp from "react-countup";
import { Grid } from "@mui/material";

const PlaceStatistics = ({ data = [] }) => {
  return (
    <MDBox>
      <Grid container spacing={2}>
        {data.map((place, index) => (
          <Grid item xs={12} md={4} lg={3} key={index}>
            <Card sx={{ p: 2, textAlign: "center", minHeight: "150px" }}>
              {/* Total Renewals Center */}
              <MDTypography variant="h3" fontWeight="bold">
                <CountUp
                  start={0}
                  end={place.totalRenewal || 0}
                  duration={1.5}
                  separator=","
                />
              </MDTypography>

              {/* Parking Code */}
              <MDTypography variant="button" color="text" fontWeight="medium">
                {place.parkingCode || "N/A"}
              </MDTypography>

              <Divider sx={{ my: 2 }} />

              {/* Row of stats */}
              <MDBox
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                flexWrap="wrap"
              >
                <MDTypography
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Renewals: {place.totalRenewal}
                </MDTypography>
                <MDTypography
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Canceled: {place.totalCanceled}
                </MDTypography>
                <MDTypography
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Failed: {place.totalFailed}
                </MDTypography>
              </MDBox>
            </Card>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
};

export default PlaceStatistics;
